import React, { useCallback } from 'react'
import { getConfig } from '../../../../config'
import { InstallType } from '../../../../lib/hooks/install-eligibility'
import { setCookie, Cookie } from '../../../../lib/utils/cookies'
import {
  BrowserSpecificExtensionInstallButtonBase,
  BrowserSpecificExtensionInstallButtonProps,
} from './browser-specific'

const { downloadUrl } = getConfig().products.extension.chrome

export type ChromeInstallButtonProps = BrowserSpecificExtensionInstallButtonProps

export const ChromeInstallButton: React.FC<ChromeInstallButtonProps> = (props) => {
  const handleInstall = useCallback(() => {
    setCookie(Cookie.grChromeStoreInstallUTM, true)
    window.open(downloadUrl, '_blank')
  }, [])

  return (
    <BrowserSpecificExtensionInstallButtonBase
      {...props}
      installUrl={downloadUrl}
      onClick={handleInstall}
      install={InstallType.Chrome}
    />
  )
}
